import "../assets/styles/views/account.scss";
import { useOutletContext } from "react-router-dom";
import UserRounded from "../assets/icons/user-rounded";
import { useState, useEffect } from "react";
import {
  change_notification_status,
  change_status_secondary_user,
  get_secondary_users_list,
  get_user_pv,
  payer_code_verify,
  update_pv_list,
} from "../utils/endpoints";
import BackArrowButton from "../components/BackArrowButton";

export default function Account() {
  const [context, setContext] = useOutletContext();
  const [selected_pv, setSelectedPv] = useState();
  const [pv_list, setPvList] = useState();
  const [users, setUsers] = useState();

  useEffect(() => {
    if (!!context.session) {
      if (!users && context.session?.profileTypeCode === "GESTORE") {
        (async () => {
          let response = await context.httpRequest(
            "get",
            `${get_user_pv}?email=${context.session?.email}`,
            null,
            context.session.token
          );
          if (response?.result && response?.data) {
            if (response.data.length > 0) {
              let pv = response.data[0].listaPv;
              if (pv) setSelectedPv(pv.split(","));

              let response_pv = await context.httpRequest(
                "get",
                payer_code_verify.replace("*", response.data[0].codiceCliente)
              );
              if (response_pv?.result && response_pv?.data)
                setPvList(response_pv.data.puntiVendita);
            }
          }

          let response_user_list = await context.httpRequest(
            "get",
            get_secondary_users_list,
            null,
            context.session.token
          );
          if (response_user_list.result) setUsers(response_user_list.data);
        })();
      }
    }
  }, [context.session]);

  const handleUserStatus = async (id) => {
    let response = await context.httpRequest(
      "get",
      change_status_secondary_user.replace("*", id),
      null,
      context.session.token
    );
    if (response.result) {
      let obj = [...users];
      obj.find((x) => {
        if (x.id === id) {
          x.active = !x.active;
          if (x.active)
            context.openMessage(
              "success",
              "L'utente è stato attivato, riceverai una e-mail con le credenziali per accedere"
            );
          else context.openMessage("success", "L'utente è stato disattivato");
        }
      });

      setUsers(obj);
    }
  };

  const handlePvChange = async (e) => {
    e.preventDefault();
    const checked_pv = e.target.querySelectorAll("input:checked");

    let final_obj = [];
    checked_pv.forEach((element) => {
      final_obj.push(element.value);
    });

    if (final_obj.length > 0) {
      let response = await context.httpRequest(
        "put",
        update_pv_list,
        final_obj,
        context.session.token
      );

      if (response.result) {
        setSelectedPv(final_obj);
      }
    } else
      context.openMessage(
        "warning",
        "Devi avere almeno un punto vendita attivo"
      );
  };

  const changeNotifiedStatus = async (e) => {
    let response = await context.httpRequest(
      "post",
      change_notification_status,
      e.target.checked,
      context.session.token
    );

    if (response.result) {
      let new_session = { ...context.session };
      new_session.emailNotificationsEnabled =
        response.data.isEmailNotificationActive;
      setContext({ session: new_session });
    }
  };

  if (context && context.session) {
    return (
      <>
        <BackArrowButton path="/" />
        <section
          className={`account ${
            context.session?.profileTypeCode === "GESTORE" ? "large-form" : ""
          } my-md-5 main-panel w-100 p-3 d-md-flex`}
        >
          <div className="w-100">
            <h1 className="mt-0 mb-3">Il tuo account</h1>
            <div className="account_card border shadow-sm p-3 mb-3">
              <strong className="mb-3 d-block">I tuoi dati</strong>
              <div className="d-flex align-items-center mb-2">
                <UserRounded color="#20419a" className="me-3" size={40} />
                <div>
                  <span className="d-block">{`${context.session?.firstName} ${context.session?.lastName}`}</span>
                  <span className="d-block">{context.session?.email}</span>
                </div>
              </div>
              <button
                onClick={() => context.navigateUrl("/change-password")}
                className="mt-3 p-3 w-100 q8-blue-button"
              >
                REIMPOSTA LA TUA PASSWORD
              </button>
            </div>

            {!context.session?.parentId ? (
              <div className="account_card border shadow-sm p-3 mb-3">
                <strong className="mb-2 d-block">Gestione notifiche</strong>
                <div className="d-flex align-items-center">
                  <span className="me-auto">
                    Attiva/disattiva le notifiche E-mail
                  </span>
                  <label className="switch ms-auto">
                    <input
                      onChange={(e) => changeNotifiedStatus(e)}
                      type="checkbox"
                      checked={context.session.emailNotificationsEnabled}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            ) : null}
          </div>
          {context.session?.profileTypeCode === "GESTORE" ? (
            <div className="w-100 ms-md-4">
              <div className="account_card border shadow-sm p-3 mb-3">
                <strong className="d-block">Gestione punti vendita</strong>
                {pv_list ? (
                  <form id="pv-form" onSubmit={(e) => handlePvChange(e)}>
                    {pv_list.map((item, index) => {
                      return (
                        <div className="d-flex pv-chose align-items-center py-3 border-bottom">
                          <small className="me-auto">
                            {item.codicePv} - {item.indirizzo}
                          </small>
                          {!context.session?.parentId && pv_list.length > 1 ? (
                            <label className="switch ms-auto">
                              <input
                                onChange={() =>
                                  document
                                    .querySelector("#pv-form")
                                    .requestSubmit()
                                }
                                value={item.codicePv}
                                type="checkbox"
                                checked={
                                  selected_pv &&
                                  selected_pv.includes(item.codicePv)
                                }
                              />
                              <span className="slider"></span>
                            </label>
                          ) : null}
                        </div>
                      );
                    })}
                  </form>
                ) : (
                  <span className="d-block text-center mt-3">
                    Non ci sono punti vendita
                  </span>
                )}
              </div>
              {users && !context.session?.parentId ? (
                <div className="account_card border shadow-sm p-3 mb-3">
                  <strong className="mb-3 d-block">
                    Gestione utenze secondarie
                  </strong>

                  {users.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className="role-card d-flex align-items-center border-bottom pb-3 mb-3"
                      >
                        <UserRounded
                          size={40}
                          className="me-3"
                          color="#67686b"
                        />
                        <span className="me-auto">USER-0{index + 1}</span>
                        <label className="switch ms-auto">
                          <input
                            checked={item.active}
                            type="checkbox"
                            onChange={() => handleUserStatus(item.id)}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          ) : null}
        </section>
      </>
    );
  }
}
